import { GivingOldTheme } from '@pushpay/theming';
export const getButtonColor = theme => {
  const isGivingOld = GivingOldTheme.colors['product-color'] === theme.colors['product-color']; // back compatibility for giving old(red)

  return {
    PRIMARY: {
      DEFAULT: {
        COLOR: theme.colors['palette-white'],
        BACKGROUND: theme.colors['product-color']
      },
      HOVER: {
        BACKGROUND: theme.colors['product-color-dark-100']
      },
      ACTIVE: {
        BACKGROUND: theme.colors['product-color-dark-200']
      },
      DISABLED: {
        COLOR: theme.colors['palette-white'],
        BACKGROUND: theme.colors['palette-grey-light-100']
      }
    },
    SECONDARY: {
      DEFAULT: {
        COLOR: theme.colors['product-color'],
        BACKGROUND: theme.colors['color-background-surface'],
        BORDER: theme.colors['product-color']
      },
      HOVER: {
        BACKGROUND: theme.colors['product-color-light-400']
      },
      ACTIVE: {
        BACKGROUND: theme.colors['product-color-light-300']
      },
      DISABLED: {
        COLOR: theme.colors['color-text-button-disabled'],
        BACKGROUND: theme.colors['color-background-surface'],
        BORDER: theme.colors['palette-grey-light-100']
      }
    },
    TERTIARY: {
      DEFAULT: {
        COLOR: theme.colors['color-text-default'],
        BACKGROUND: theme.colors['palette-transparent']
      },
      HOVER: {
        BACKGROUND: theme.colors['palette-grey-light-300']
      },
      ACTIVE: {
        BACKGROUND: theme.colors['palette-grey-light-200']
      },
      DISABLED: {
        COLOR: theme.colors['color-text-button-disabled'],
        BACKGROUND: theme.colors['palette-transparent']
      }
    },
    TEXT: {
      DEFAULT: {
        COLOR: isGivingOld ? '#1073BC' : theme.colors['product-color'],
        BACKGROUND: theme.colors['palette-transparent']
      },
      HOVER: {
        BACKGROUND: isGivingOld ? '#ECF4FA' : theme.colors['product-color-light-400']
      },
      ACTIVE: {
        BACKGROUND: isGivingOld ? '#D9E8F4' : theme.colors['product-color-light-300']
      },
      DISABLED: {
        COLOR: theme.colors['color-text-button-disabled'],
        BACKGROUND: theme.colors['palette-transparent']
      }
    },
    ACTION: {
      DEFAULT: {
        COLOR: theme.colors['color-text-default'],
        BACKGROUND: theme.colors['palette-white'],
        BORDER: theme.colors['palette-grey']
      },
      HOVER: {
        COLOR: theme.colors['color-text-default'],
        BACKGROUND: theme.colors['palette-white'],
        BORDER: theme.colors['palette-grey-dark-400']
      },
      ACTIVE: {
        COLOR: theme.colors['color-text-default'],
        BACKGROUND: theme.colors['palette-white'],
        BORDER: theme.colors['palette-grey-dark-400']
      },
      DISABLED: {
        COLOR: theme.colors['color-text-button-disabled'],
        BACKGROUND: theme.colors['palette-white'],
        BORDER: theme.colors['palette-grey-light-100']
      }
    }
  };
};